import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, input, effect, inject } from '@angular/core';
import { SortOrder } from "../../../types/table.type";

@Component({
    selector: 'th[emsysCell], td[emsysCell]',
    templateUrl: './table-cell.component.html',
    styleUrls: ['./table-cell.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class TableCellComponent {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);


  useForSorting: boolean = false;

  readonly isHeading: boolean = false;

  @HostBinding('class.cursor-pointer')
  get applySortableClass() {
    return this.sortable();
  }

  readonly sortable = input<boolean>(false);

  readonly ariaSort = input<SortOrder>('');

  @HostBinding('attr.aria-sort')
  protected get ariaSortAttr() {
    return this.ariaSort();
  }

  @HostBinding('class.group')
  protected get groupClass() {
    return this.ariaSort() !== '';
  }

  constructor() {
    this.isHeading = this.elementRef.nativeElement.tagName.toUpperCase() === 'TH';

    // Handle side effects that were previously in the setter
    effect(() => {
      const value = this.ariaSort();

      if (!this.isHeading) {
        this.useForSorting = false;
        return;
      }

      this.useForSorting = value !== '';
    });
  }

}
